import React, { useState } from 'react';
import { useQuery } from '@apollo/client';
import {
  CalendarOutlined,
  CloseOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { PaymentCard, ClickOut } from '..';
import Wrapper from './style';
import { TimeFormatter } from '../../utils/timeParser';
import { paymentUnlicensedBg } from '../../assets';
import { GET_LIST_TEAM_LICENSE_DETAIL } from '../../graphql/queries';
import {
  typeList,
  userLicenseTitle,
  renewalType as renewalTypeOptions,
} from '../../configs/license';
import { AuthService } from '../../services';

const Index = (props) => {
  const { activeLicense, isPersonal } = props;
  const userData = AuthService.getUserData();
  const teamData = userData?.team;

  const licenseData = activeLicense ?? {};
  const type = licenseData?.team?.type || teamData?.type;
  const licenseType = userLicenseTitle?.[type];
  const userType = userLicenseTitle?.[type];
  const [isShow, setIsShow] = useState(false);

  const { data } = useQuery(GET_LIST_TEAM_LICENSE_DETAIL, {
    variables: {
      where: {
        team_license_id: activeLicense?.id,
      },
      skip: JSON.stringify(activeLicense) === '{}',
    },
  });
  const detailLicense = data?.GetTeamLicenseDetailList?.data?.[0] || {};
  const licenseCreatedAt = detailLicense?.paid_at;
  const licenseExpiredAt = detailLicense?.expired_at;
  const renewalType = detailLicense?.renewal_type;

  const selectedRenewal = renewalTypeOptions.filter((item) => {
    return item.value === renewalType;
  });
  const isSelectedType = typeList.find((item) => {
    return item.value === licenseData?.license_id;
  });

  const onParseCreateAt = () => {
    if (licenseCreatedAt === null) return '-';
    const start = TimeFormatter(licenseCreatedAt);
    return `${start.date} ${start.monthName} ${start.year} | ${start.hour}:${start.min}:${start.milliseconds}`;
  };

  const onParseExpiredAt = () => {
    if (licenseExpiredAt === null) return '-';
    const end = TimeFormatter(licenseExpiredAt);
    return `${end.date} ${end.monthName} ${end.year} | ${end.hour}:${end.min}:${end.milliseconds}`;
  };
  return (
    <Wrapper bgImage={isSelectedType?.image || paymentUnlicensedBg}>
      <div className="container_setting_license_hero_info">
        {!isPersonal && (
          <div className="font-header3_medium">{`License for ${userType}`}</div>
        )}
        {isPersonal && (
          <>
            <div className="font-header3_medium">Personal License</div>
            <div className="font-paragraph">
              License used for your team can use feature in App
            </div>
          </>
        )}
        {isSelectedType && (
          <div className="component_info_license_date">
            <div
              aria-hidden="true"
              className="component_info_license_date_btn"
              onClick={() => {
                setIsShow(true);
              }}
            >
              <CalendarOutlined size={20} />
              <div className="font-paragraph_medium">
                {`Activated for ${selectedRenewal?.[0]?.period ?? ''}`}
              </div>
              <RightOutlined size={20} />
            </div>
            <ClickOut
              onClickOutside={() => {
                setIsShow(false);
              }}
            >
              {isShow && (
                <div className="component_info_license_date_action_box">
                  <div className="component_action_box_header">
                    <div className="font-paragraph_medium">License Date</div>
                    <div
                      className="component_close"
                      aria-hidden="true"
                      onClick={() => {
                        setIsShow(false);
                      }}
                    >
                      <CloseOutlined />
                    </div>
                  </div>
                  <div className="component_action_box_body">
                    <div className="component_action_box_body_item">
                      <div className="font-paragraph_medium">Paid Date</div>
                      <div className="font-paragraph">{onParseCreateAt()}</div>
                    </div>
                    <div className="component_action_box_body_item">
                      <div className="font-paragraph_medium">Expired At</div>
                      <div className="font-paragraph">{onParseExpiredAt()}</div>
                    </div>
                  </div>
                </div>
              )}
            </ClickOut>
          </div>
        )}
      </div>
      <div className="container_setting_license_hero_card">
        <PaymentCard
          licenseName={licenseData?.name}
          licenseKuota={licenseData?.max_team_member}
          licenseMax={licenseData?.max_socmed_account}
          licensePrice={
            detailLicense?.[selectedRenewal?.[0]?.teamLicenseAttr] -
            detailLicense?.discount
          }
          licenseType={licenseData?.license_id}
          licenseTypeName={licenseType}
        />
      </div>
    </Wrapper>
  );
};

export default Index;
